import axios from "../../axios";

const state = {
    partenersList: [],
    filter: { page: 1 },
    last_page: 0,
    baseUrl: 'https://www.althawri.com/',
};

const getters = {
    getpartenersList: state => state.partenersList,
    getFilter: state => state.filter,
    getLastPage: state => state.last_page,


};
const mutations = {
    setpartenersList(state, payload) {
        state.partenersList = payload;
    },
    setLastPage(state, payload) {
        state.last_page = payload;
    },
    setFilter(state, payload) {
        state.filter = payload;
    },
    setImageURL(state, payload) {
        state.image = (state.baseUrl + payload);
    },
    addparteners(state, payload) {
        state.partener = payload;
    }



};
const actions = {
    fetchpartenersList({ state, commit }, query) {
        let search = query.search ? query.search : "";
        search ? state.filter = { page: 1 } : state.filter = { page: state.filter.page };
        return axios.get(`/api/admin/parteners`, { params: state.filter })
            .then((response) => {
                commit("setpartenersList", response.data.data)
                commit("setLastPage", response.last_page);
                console.log(response.data);
                return response;
            }).catch((error) => {
                for (let i = 0; i < Object.keys(error.response.data).length; i++) {
                    console.log(Object.values(error.response.data)[i].toString());
                }
            });
    },

    //postpartener
    postpartener({ commit }, partener) {

        let formData = new FormData();
        formData.append("titleAr", partener.titleAr);
        formData.append("titleEn", partener.titleEn);
        formData.append("placeAr", partener.placeAr);
        formData.append("placeEn", partener.placeEn);
        formData.append("detailsAr", partener.detailsAr);
        formData.append("detailsEn", partener.detailsEn);
        formData.append("hours", partener.hours);
        formData.append("shift", partener.shift);
        return axios.post(`api/admin/parteners`, formData).then((response) => {
            console.log("تم اضافة المنتج بنجاح");
            commit("addparteners", response.data)
            return response;
        }).catch((error) => {
            for (let i = 0; i < Object.keys(error.response.data).length; i++) {
                console.log(Object.values(error.response.data)[i].toString());
            }
        });
    },




    //updatepartener
    updatepartener({ commit }, partener) {
        let image = (`https://www.althawri.com/`, partener.image); //concat the image url
        let formData = new FormData();
        formData.append("name", partener.name);
        formData.append("price", partener.price);
        formData.append("image", image);
        formData.append("nameAr", partener.nameAr);
        formData.append("category_id", partener.category_id);
        console.log("image out ", image);
        if (typeof(image) != "object" || image == null) {
            formData.delete('image');
        }
        return axios.post(`/api/admin/parteners/${partener.id}?_method=PUT`, partener).then((response) => {
            commit("setpartener", response.data)
                // commit("setImageURL", response.data.image)
            console.log(response.data.image);
            console.log("image state", state.image);

            console.log("data sent")
            return response;
        }).catch((err) => {
            for (let i = 0; i < Object.keys(err.response.data).length; i++) {
                console.log(Object.values(err.response.data.errors)[i].toString());
            }
        });
    },



    deletepartener({ commit }, id) {
        return axios.delete(`/api/parteners/${id}`).then((response) => {
            commit("deletepartener", id)
            return response;
        }).catch((err) => {
            for (let i = 0; i < Object.keys(err.response.data).length; i++) {
                console.log(Object.values(err.response.data.errors)[i].toString());
            }
        });

    },


    getSinglepartener({ commit }, id) {
        return axios.get(`/api/admin/parteners/${id}`).then((response) => {
            commit("setpartener", response.data)
            return response;
        }).catch((error) => {
            for (let i = 0; i < Object.keys(error.response.data).length; i++) {
                console.log(Object.values(error.response.data)[i].toString());
            }
        });
    }


};

export default {
    namespaced: true,
    name: "parteners",
    state,
    getters,
    actions,
    mutations,
};